import React from 'react';

const stickyBarStart = (data) => {
  const stickyAttribute = data.stickyAttribute ? data.stickyAttribute : null;
  return <section data-sticky={stickyAttribute} />;
};

export default stickyBarStart;
